import classNames from 'classnames';
import * as React from 'react';
// Constants
import { AGREEMENT_TYPE } from '../constants';
// Components
import Enterprise from './enterprise';
import OneOff from './one-off';
import RuptlyPass from './ruptly-pass';

const DownloadSliderAgreement = ({
  agreement = {},
  form,
  entity,
  multiple,
  price,
  isRepeated
}) => {
  const Component =
    agreement.agreement_type === AGREEMENT_TYPE.RUPTLY_PASS
      ? RuptlyPass
      : agreement.agreement_type === AGREEMENT_TYPE.ONE_OFF
      ? OneOff
      : Enterprise;

  const isLimit = agreement?.can_download_content.why_not_reason === 'limit';
  const disabled = !agreement?.can_download_content.can || agreement?.can_download_content.why_not_reason !== 'none';

  return (
    <div className={classNames('side-buy-plan', { 'radio-button': multiple })}>
      <input
        checked={agreement.id === form.agreement_id}
        className="radio-button__input"
        disabled={disabled}
        id={agreement.id}
        name="agreement_id"
        type="radio"
        value={agreement.id}
      />
      <label
        className={classNames('side-popup__subtitle', {
          'radio-button__label': multiple,
          'side-popup__subtitle--reached': isLimit
        })}
        htmlFor={agreement.id}
      >
        {agreement.name}
      </label>

      <Component
        agreement={agreement}
        entity={entity}
        form={form}
        isRepeated={isRepeated}
        price={price}
      />
    </div>
  );
};

export default DownloadSliderAgreement;
